import React from 'react';
import PropTypes from 'prop-types';
import { Menu } from '@storable/canaveral-components';
import styles from './styles.scss';

const propTypes = {
  className: PropTypes.string,
  componentClass: PropTypes.element.isRequired,
};

const defaultProps = {
  className: undefined,
};

const PagesMenuLoading = ({
  className,
  componentClass: MenuItemLoading,
}) => {
  const header = (
    <Menu.Header>
      <div className={styles.loadingIndicatorHeader} />
    </Menu.Header>
  );

  return (
    <Menu
      className={className}
      header={header}
    >
      <MenuItemLoading />
      <MenuItemLoading />
      <MenuItemLoading />
      <MenuItemLoading />
      <MenuItemLoading />
    </Menu>
  );
};

PagesMenuLoading.propTypes = propTypes;
PagesMenuLoading.defaultProps = defaultProps;

export default PagesMenuLoading;
